// extracted by mini-css-extract-plugin
export var container = "_b8-0";
export var icon = "_b8-1";
export var text = "_b8-2";